export enum SignalRHub {
  BASKET = "basket",
  MENUPLANNER = "menuplannerapi",
  MENU_PLAN__REPLACE = "menuPlanReplace",
  MENSA__EXPORT = "mensamaxexportinfo",
  MENU_SELECTION_ORDER = "menuselection",
}
